/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : NonMSAKeyOnlyConfirmConfiguration.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422337
*
* @Date         : Oct 08, 2020
*
* @Version      : Version 1.0
*
*
******************************************************************************/
import * as React from 'react';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import './ConfigureAPU.css';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import DisplayCustTypeCard from './DisplayCustTypeCard';
import CheckoutConstants from '../constants/checkout-constants';
import NonMSAKeyOnlyConfigSummary from './NonMSAKeyOnlyConfigSummary';
import TotalPriceCard from './TotalPriceCard';
import DisplayPurchaseTypeCard from './DisplayPurchaseTypeCard';

interface INonMSAKeyOnly {
    productData: any;
    gotoCustomerCategoryTab: Function;
    gotoProductConfigureTab: Function;
    gotoProductPurchaseTab: Function;
    totalPrice: any;
    purchaseType: number;
}

function NonMSAKeyConfirmConfiguration(props: INonMSAKeyOnly) {
    return(
        <div className="confirmation-step-card">
            <DisplayCustTypeCard gotoCustomerCategoryTab={props.gotoCustomerCategoryTab} customerType={CheckoutConstants.CUSTOMER_CATEGORY_NONMSA}/>
            <DisplayPurchaseTypeCard gotoProductPurchaseTab={props.gotoProductPurchaseTab} purchaseTypeSubText={CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_KEY_ONLY} />
            <NonMSAKeyOnlyConfigSummary productData={props.productData} gotoProductConfigureTab={props.gotoProductConfigureTab} />
            <TotalPriceCard totalPrice={props.totalPrice} />
        </div>
    );
}

const mapDispatchToProps = {
    gotoCustomerCategoryTab: ConfigureAPUActions.gotoCustomerCategoryTab,
    gotoProductConfigureTab: ConfigureAPUActions.gotoNonMsaProductConfigureTab,
    gotoProductPurchaseTab: ConfigureAPUActions.gotoProductConfigureTab,
};

function mapStateToProps(state) {
    return {
        totalPrice: state.configAPUData.payload.totalPrice,
        purchaseType: state.configAPUData.payload.purchaseType,
        productData: state.configAPUData.payload.nonMsaKeyOnlyOrderConfigData,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NonMSAKeyConfirmConfiguration);